import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const CompanySettingsBypassPage = () => {
  const navigate = useNavigate()

  useEffect(() => {
    navigate('/settings/company-settings/overview')
  }, [])
  return (
    <>
    </>
  )
}